import { BannerHero, Container } from "@/components/site/Layout";
import { LeadershipGrid } from "@/components/site/Leadership";
import { LEADERSHIP_INTRO } from "@/lib/leadership";
import { useSeo } from "@/lib/useSeo";

export default function LeadershipPage() {
  useSeo({ title: "Leadership | America First Refining", description: "Meet the senior management team of America First Refining: industry veterans in refining, trading, finance and capital projects.", path: "/leadership" });
  return (
    <div data-testid="leadership-page">
      <BannerHero testId="leadership-banner" title="Leadership" image="/img/banner-leadership.jpg" alt="Engineer holding a hard hat in front of refinery towers" intro={LEADERSHIP_INTRO} />
      <Container id="team" testId="leadership-section">
        <LeadershipGrid />
      </Container>
    </div>
  );
}
